document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.item-number-select').forEach(function (container) {
		const input = container.querySelector('.input-number');
		const minusBtn = container.querySelector('.number-btn[data-type="minus"]');
		const plusBtn  = container.querySelector('.number-btn[data-type="plus"]');

		const min = parseInt(input.getAttribute('min'), 10) || 1;
		const maxAttr = input.getAttribute('max');
		const max = maxAttr ? parseInt(maxAttr, 10) : null;

		function updateButtons() {
			const value = parseInt(input.value, 10);
			if (value <= min) {
				minusBtn.setAttribute('disabled', 'disabled');
			} else {
				minusBtn.removeAttribute('disabled');
			}
			if (max !== null && value >= max) {
				plusBtn.setAttribute('disabled', 'disabled');
			} else {
				plusBtn.removeAttribute('disabled');
			}
		}

		minusBtn.addEventListener('click', function (e) {
			e.preventDefault();
			let value = parseInt(input.value, 10);
			if (isNaN(value)) value = min;
			if (value > min) {
				input.value = value - 1;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			}
			updateButtons();
		});

		plusBtn.addEventListener('click', function (e) {
			e.preventDefault();
			let value = parseInt(input.value, 10);
			if (isNaN(value)) value = min;
			if (max === null || value < max) {
				input.value = value + 1;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			}
			updateButtons();
		});

		input.addEventListener('focusin', function () {
			input.dataset.oldValue = input.value;
		});

		input.addEventListener('change', function () {
			let value = parseInt(input.value, 10);
			if (isNaN(value)) value = min;
			if (value < min) value = min;
			if (max !== null && value > max) value = max;
			input.value = value;
			updateButtons();
		});

		input.addEventListener('keydown', function (e) {
			const allowed = [46, 8, 9, 27, 13];
			if (
				allowed.includes(e.keyCode) ||
				(e.keyCode === 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)
			) return;
			if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// 初期化
		updateButtons();
	});
});
